export function scoreColor(score) {
  if (score == null) return { hex: "#86868B", bg: "rgba(134,134,139,0.1)", label: "—" };
  if (score >= 7) return { hex: "#34C759", bg: "rgba(52,199,89,0.1)", label: "High" };
  if (score >= 4) return { hex: "#D4AA00", bg: "rgba(255,204,0,0.14)", label: "Medium" };
  return { hex: "#FF3B30", bg: "rgba(255,59,48,0.1)", label: "Low" };
}

export default function ScoreRing({ score, size = 56, stroke = 5, pending = false }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = score == null ? 0 : Math.max(0, Math.min(10, score)) / 10;
  const { hex } = scoreColor(score);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#EDEDED" strokeWidth={stroke} />
        {!pending && (
          <circle
            cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={hex} strokeWidth={stroke}
            strokeDasharray={circ} strokeDashoffset={circ * (1 - pct)} strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.16,1,0.3,1)" }}
          />
        )}
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        {pending ? (
          <span className="text-[10px] font-semibold text-[#86868B] animate-pulse">AI…</span>
        ) : (
          <span className="font-extrabold tracking-tight" style={{ color: hex, fontSize: size * 0.32 }}>
            {score == null ? "—" : score.toFixed(1)}
          </span>
        )}
      </div>
    </div>
  );
}
